type RenderOnboardingProps = {
    readonly consentStatus?: 'no' | 'outdated' | 'yes';
    readonly onboardingRoutesPath: string;
    readonly pathname: string;
    readonly userProfileExists: boolean;
};

export const shouldRenderOnboarding = ({
    consentStatus,
    onboardingRoutesPath,
    pathname,
    userProfileExists,
}: RenderOnboardingProps): boolean => {
    const currentPathnameIsNotOnboarding = pathname !== onboardingRoutesPath;

    return (
        (consentStatus !== 'yes' && currentPathnameIsNotOnboarding) ||
        (userProfileExists === false && currentPathnameIsNotOnboarding)
    );
};
